// material-ui
import { Card, CardContent, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

 const gridSpacing  = 3;

const TotalGrowthBarChart = () => (
  <Card elevation={0} className="!tw-rounded-xl !tw-border-0 !tw-bg-slate-50 tw-shadow-none dark:!tw-bg-slate-900">
    <CardContent>
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
            <Grid item xs zeroMinWidth>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Skeleton variant="text" />
                </Grid>
                <Grid item xs={12}>
                  <Skeleton className="tw-rounded-lg" variant="rectangular" height={20} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Skeleton className="tw-rounded-lg" variant="rectangular" height={50} width={80} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Skeleton className="tw-h-[clamp(360px,52vw,480px)] tw-rounded-xl" variant="rectangular" />
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default TotalGrowthBarChart;
